import { VoucherSliceState } from 'src/core/models'

const vouchersState: VoucherSliceState = {
  campaings: {
    loading: false,
    data: []
  },
  createCampaign: {
    loading: false,
    success: false,
    hasExistsError: false
  },
  createDiscountVoucher: {
    loading: false,
    success: false,
    hasOnwerError: false
  }
}

export { vouchersState as initialState }
